<template lang="pug">
div.py-20
  .container 
    //- pre hhj {{config}}
    .flex.flex-wrap.justify-between.items-center(class="-mx-4")
      .flex-none.px-4(class="w-full lg:w-1/2 mb-12 lg:mb-0")
        h4.text-3xl.text-blue-500.mb-4.font-semibold(v-html="title")
        div(v-html="subtitle")
      .flex-none.px-4(class="w-full lg:w-5/12")
        CarouselSliderBlock(v-bind="{slides, navType:false, showTopBorder: true}")
    //- pre {{slides}}
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import CarouselSliderBlock from "@components/common-blocks/carousels/CarouselSliderBlock.vue";
const mounted = ref(false);
onMounted(() => {
  mounted.value = true;
});

const { config } = defineProps({
  config: {
    type: Object,
    default: () => ({
      slides: [],
    }),
  },
});
const { title, subtitle, slides } = config;
</script>
